import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  showBillingIssues = signal<boolean>(false);
  billingMessage = signal<string>(
    'Please pay overdue invoice(s) before 10pm Thursday 12th February to prevent service interruption.'
  );

  constructor() {}

  setBillingIssues(show: boolean): void {
    this.showBillingIssues.set(show);
  }

  setBillingMessage(message: string): void {
    this.billingMessage.set(message);
  }

  dismissBillingAlert(): void {
    this.showBillingIssues.set(false);
  }
}
